/** @jsx jsx */
import styled from '@emotion/styled';
import Select from 'react-select';

import theme from 'theme/theme';

const StyledSelect = styled(Select)({
  zIndex: theme.zIndices[1],
  '& .resource-center__indicator': {
    color: theme.colors.coolGrey[90]
  },
  '& .resource-center__indicator-separator': {
    display: 'none'
  },
  '& .resource-center__control': {
    background: 'transparent',
    border: 'none',
    borderRadius: 0,
    borderBottom: `1px solid ${theme.colors.coolGrey[90]}`,
    minHeight: '2.5rem',
    '&:hover': {
      cursor: 'pointer'
    },
    '&--is-focused': {
      boxShadow: `0 0 2px 2px ${theme.colors.blue[60]}`
    }
  },
  '& .resource-center__value-container': {
    padding: theme.space[0]
  },
  '& .resource-center__menu-list': {
    display: 'flex',
    flexWrap: 'wrap'
  },
  '& .resource-center__option': {
    flex: '0 1 50%',
    '&:hover': {
      cursor: 'pointer'
    },
    '&--is-focused, &--is-selected': {
      color: theme.colors.orange[30],
      background: theme.colors.white
    }
  }
});

export default StyledSelect;
